import { Component } from '@angular/core';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { IInvoice } from 'src/app/interfaces/iinvoice';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GeneralService } from 'src/app/services/general.service';
import { InvoiceService } from 'src/app/services/invoice.service';

@Component({
    selector: 'app-single-paper-invoice',
    templateUrl: './single-paper-invoice.component.html',
    styleUrls: ['./single-paper-invoice.component.scss'],
    standalone: false
})
export class SinglePaperInvoiceComponent {
     isDownloading: boolean = false;
     periodList: string[] = [];
     companyType: string = 'MC';
     billingPeriod: string = '';
     loginEmail: string = '';
     reportType: string = 'PDF';
     reportLevel: string = '1';
     showTotals: string = '0';
     orderByLogin: string = '0';
     customerId: string = '';
     userProfile?: UserProfile;
     invoiceId: string = '';
     billCycleInvoices: IInvoice[] = [];
     showNoInvoicesAlert: boolean = false;
     showInvoiceDownloadedAlert: boolean = false;
     showReportDownloadedAlert: boolean = false;
     constructor(public generalService: GeneralService,
          private authenticationService: AuthenticationService, public invoiceService: InvoiceService) {
          this.userProfile = this.authenticationService.getUserProfile() as UserProfile;
          this.customerId = this.userProfile!.customerId;
          this.loginEmail = this.userProfile!.userData.userName;
          this.periodList = invoiceService.getCdbBillingCyclesList();
          this.billingPeriod = this.periodList[0];

          this.scrollToTop();
     }

     pageValid(): boolean {
          if (this.billingPeriod && this.loginEmail && Number(this.customerId) && this.showTotals && this.orderByLogin ) {
               return true;
          }
          return false;
     }

     downloadReport() {
          this.isDownloading = true;
          this.showInvoiceDownloadedAlert = false;
          this.showNoInvoicesAlert = false;
          if (this.billingPeriod === '') {
               console.error("No billing period selected");
               return;
          }

          if (this.invoiceId === '') {
               this.invoiceService.getInvoicesByBillCycle(this.billingPeriod).subscribe((result: any) => {
                    this.isDownloading = false;
                    this.billCycleInvoices = result as IInvoice[];

                    if (this.billCycleInvoices?.length === 1) {
                         this.invoiceId = this.billCycleInvoices[0].invoiceId;
                         this.downloadReport();
                    }else if(this.billCycleInvoices?.length > 1){
                         this.invoiceId = this.billCycleInvoices.find(bc => bc.billCycle === this.billingPeriod)?.invoiceId || "";
                         if(this.invoiceId === ""){
                              this.showNoInvoicesAlert = true;
                         }else{
                              this.downloadReport();
                         }
                    } else if (!this.billCycleInvoices || this.billCycleInvoices?.length === 0) {
                         this.showNoInvoicesAlert = true;
                    }
               });
               return;
          }

          this.isDownloading = true;
          const userProfile = this.authenticationService.getUserProfile() as UserProfile;
          this.invoiceService.GetInvoicePdfById(Number(this.customerId), Number(this.invoiceId)).subscribe((result: any) => {
               const filename = `Invoice-${this.billingPeriod}.pdf`;
               const element = document.createElement('a');
               element.setAttribute('href', 'data:application/octet-stream;base64,' + result);
               element.setAttribute('download', filename);
               element.style.display = 'none';
               document.body.appendChild(element);
               element.click();
               document.body.removeChild(element);
               this.isDownloading = false;
               this.showInvoiceDownloadedAlert = true;
          });
     }

     openDocument(docName: string) {
          this.generalService.openDocument(docName);
     }

     clearInvoices() {
          this.invoiceId = '';
          this.billCycleInvoices = [];
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }
}
